const DISH_ACTION_TYPES = {
  LOAD_DISH: 'dish/LOAD_DISH',
};

export default DISH_ACTION_TYPES;
